import React, {useEffect} from "react";
import classes from "./E-road.module.scss";
import Heading from "../../../components/caseStudy/heading/Heading.tsx";
import Info, {Feature, Topic} from "../../../components/caseStudy/info/Info.tsx";
import logo from "./media/logo.webp";
import OtherProjects from "../../../components/caseStudy/other-projects/OtherProjects.tsx";
import {ECaseStudy} from "../../../enums/case-study.enum.ts";
import {useTranslation} from "react-i18next";
import OrganizationSeo from "../../../components/Seo/OrganizationSeo.tsx";


const ERoad = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const {t} = useTranslation();

    const title = [t('eRoad.title'), t('eRoad.blueTitle')]

    const description = [
        t('eRoad.text')
    ]

    const buttonText = t('eRoad.buttonText');

    const infoTitle = t('eRoad.info.title');

    const infoTitleMessage = t('eRoad.info.text')

    const topics: Topic[] = t('eRoad.topic', {returnObjects: true})

    const features: Feature = {
        title: t('eRoad.featuresText'),
        extendedList: t('eRoad.featuresList', {returnObjects: true})
    }

    const rightBlock = {
        platforms: t('eRoad.rightBlock.platforms', {returnObjects: true}),
        services: t('eRoad.rightBlock.services', {returnObjects: true}),
        audience: t('eRoad.rightBlock.audience', {returnObjects: true}),
        field: t('eRoad.rightBlock.field', {returnObjects: true})
    }

    return (
        <>
            <OrganizationSeo
                title="Goteco: Secure and Scalable GovTech and Business Solutions"
                description="Goteco specializes in developing secure, scalable systems that boost efficiency across public and private sectors, optimizing processes in manufacturing, e-commerce, and construction industries."
                url="https://go-te.co/"
                image="https://go-te.co/logo.svg"
            />

            <section className={classes.section} id="nav-dark">
                <Heading
                    title={title}
                    description={description}
                    maxWidth={800}
                    imageName={'e-road.webp'}
                    buttonText={buttonText}
                />

                <Info
                    title={infoTitle}
                    titleMessage={infoTitleMessage}
                    topics={topics}
                    features={features}
                    rightBlock={rightBlock}
                />

                <div className={classes["image-section"]}>
                    <div className={classes["overlay"]}></div>
                    <div className={classes["image-container"]}>
                        <img className={classes.logo} src={logo} alt="E-road logo"/>
                        <div className={classes.text}>
                            {t('eRoad.bottomText')}
                        </div>
                    </div>
                </div>

                <OtherProjects name={ECaseStudy.E_ROAD}/>
            </section>
        </>
    );
};

export default ERoad;